import type SuperJSON from "superjson";
import { TaxId } from "./TaxId";

/**
 * Register the SuperJSON transformer for TaxId.
 * Pass the SuperJSON instance you want to register on (client or server instance).
 */
export function registerTaxIdTransformer(superjson: typeof SuperJSON): void {
  superjson.registerCustom<TaxId, string>(
    {
      isApplicable: (v): v is TaxId => v instanceof TaxId,
      serialize: TaxId.serialise,
      deserialize: TaxId.deserialise,
    },
    "TaxId"
  );
}
